module.exports = __webpack_public_path__ + "img/arrow-left.543234b6.svg";